import './BookingAppointmentCss/stepTracker.css';

// const steps = ['Date & Time', 'Basic Information', 'Payment', 'Confirmation'];
const steps = ['Date & Time', 'Basic Information','Booking']

const StepTracker = ({ currentStep }) => {
  return (
    <div className="step1-tracker">
      {steps.map((step, index) => {
        const isMobileTop = index === 0 || index === 2;
        const isMobileBottom = index === 1 || index === 3;

        return (
          <div key={index} className="step1-tracker-item">
            <span
              className={`step1-label step1-label-top ${currentStep === index ? 'step1-active-label' : ''} ${isMobileTop ? 'mobile-show' : 'mobile-hide'
                }`}
            >
              {step}
            </span>

            <div className={`step1-circle ${currentStep === index ? 'step1-active' : ''}`}>
              {index + 1}
            </div>

            <span
              className={`step1-label step1-label-bottom ${currentStep === index ? 'step1-active-label' : ''} ${isMobileBottom ? 'mobile-show' : 'mobile-hide'
                }`}
            >
              {step}
            </span>
            <span
              className={`step1-label step1-label-default ${currentStep === index ? 'step1-active-label' : ''}`}
            >
              {step}
            </span>
          </div>
        );
      })}
    </div>
  );
};

export default StepTracker;
